import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { buildMortgageBannerUnderPriceIpotekaUrl } from 'shared/utils/tracking/mortgageUnderPriceCianBanner';

import { EntryPointRow } from '../EntryPointRow';
import icon from './assets/discount.svg';
import newIcon from './assets/new_discount.svg';
import { TMortgageBannerVerticalName, trackMortgageWidgetAnchorClick, trackMortgageWidgetAnchorShow } from './tracking';

interface IUiData {
  title: string;
  subtitle?: string;
  icon: string;
}

interface IMortgageWidgetPromoDiscountProps {
  mortgagePromoDesign: string | null;
  verticalName: TMortgageBannerVerticalName;
  variant?: 'old' | 'new';
}

const uiDataByVariant: Record<'old' | 'new', IUiData> = {
  old: {
    title: 'Ипотека',
    icon,
  },
  new: {
    title: 'Подобрать ипотеку',
    subtitle: 'Рассчитать и получить решение',
    icon: newIcon,
  },
};

export const MortgageWidgetPromoDiscount: React.FC<IMortgageWidgetPromoDiscountProps> = ({
  verticalName,
  variant = 'old',
}) => {
  const redirectPath = buildMortgageBannerUnderPriceIpotekaUrl(verticalName);
  const uiData = uiDataByVariant[variant];

  const handleAnchorClick = () => {
    trackMortgageWidgetAnchorClick(verticalName);
  };

  return (
    <ActionAfterViewObserver callback={() => trackMortgageWidgetAnchorShow(verticalName)} callbackDelay={1000}>
      <EntryPointRow
        dark
        onClick={handleAnchorClick}
        imgSrc={uiData.icon}
        title={uiData.title}
        subtitle={uiData.subtitle}
        link={redirectPath}
      />
    </ActionAfterViewObserver>
  );
};
